import { reducers as sharedReducers } from '@innovyze/stylovyze';
import rootReducer from './reducers';
import reduxThunk from 'redux-thunk';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { ThunkAction, Action } from '@reduxjs/toolkit';
import { initSagas, sagaMiddleware } from './sagas';
import { moduleNamespace as mapUiNamespace,
  reducers as mapUiReducers,
} from '@innovyze/map-components';
import { assetSchemaRootReducer } from '@innovyze/lib_asset_schema_store';
// State used by the isolated application only
export const root = combineReducers({
  ...assetSchemaRootReducer,
  ...sharedReducers,
  [mapUiNamespace]: mapUiReducers,
  modelFactory: rootReducer,
});

const enhancer = composeWithDevTools(applyMiddleware(sagaMiddleware, reduxThunk));

const initStore = () => {
  const store = createStore(root, enhancer);

  initSagas();

  return store;
};

const store = initStore();
// Inferred type: {...modelFactory, ...site, ...}
export type AppDispatch = typeof store.dispatch;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export default store;
